import { createFileRoute } from "@tanstack/react-router";
import PenaltyEstimatorPage from "@/features/public/pages/tools/penalty-estimator";

export const Route = createFileRoute("/(public)/_public/tools/penalty-estimator")({
  component: PenaltyEstimatorPage,
});
